var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 608 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.398 184.533C102.398 178.053 107.652 172.8 114.132 172.8H298.665L296.532 207.466L306.665 210.133L318.932 206.4L321.598 207.466V181.866C321.598 177.154 325.419 173.333 330.132 173.333H344.532H507.732C513.034 173.333 517.332 177.631 517.332 182.933V293.281C517.332 299.192 512.525 303.976 506.613 303.948L407.465 303.466L397.865 311.466L387.732 315.2L375.465 304H102.398V184.533Z",
    fill: "#4D84FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.867 226.134H262.401L249.601 244.8L244.801 239.467L237.867 226.134Z",
    fill: "#1B44A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.269 277.867L270.403 266.667H280.536L280.003 282.667L253.336 282.134L260.269 277.867Z",
    fill: "#1B44A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.469 275.733L236.269 278.933L244.269 282.133L250.669 282.667H231.469V275.733Z",
    fill: "#1B44A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M340.797 273.067V267.2H344.53L354.13 279.467L356.264 283.2L341.33 283.734L340.797 273.067Z",
    fill: "#1B44A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M383.999 270.934L380.266 267.2H388.799V274.667V276.267L385.599 272.534L383.999 270.934Z",
    fill: "#1B44A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M555.201 537.066C555.201 544.357 423.617 550.399 294.934 550.399C166.251 550.399 61.8672 544.462 61.8672 537.066C61.8672 529.67 166.251 523.732 294.934 523.732C423.617 523.732 555.201 529.67 555.201 537.066Z",
    fill: "#0D2A73"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.1,
    cy: 303.999,
    r: 22.6233,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 382.648,
    y: 159.776,
    width: 73.5256,
    height: 21.2093,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.797 159.776H238.425V180.986H210.853L208.025 176.037V180.986H174.797V159.776Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.423 335.614C387.423 335.614 369.256 318.999 362.015 303.999C356.612 292.907 349.543 279.749 336.845 274.002C335.784 263.21 335.668 252.346 336.5 241.534C337.127 230.249 334.353 213.706 330.451 211.135C327.893 209.628 325.147 208.469 322.284 207.687C324.293 213.656 325.868 219.763 326.997 225.959L294.631 226.821C293.6 220.628 292.043 214.534 289.976 208.606C287.102 209.296 284.746 209.816 282.62 210.445C282.677 210.79 294.861 255.784 283.137 249.235C285.436 259.405 289.401 276.071 291.643 279.519C281.873 342.789 269.807 470.823 267.508 493.291C280.554 498.891 295.1 499.963 308.827 496.337C308.827 496.337 325.835 365.487 328.488 335.605L371.071 371.637C374.688 374.733 378.946 376.99 383.539 378.246L445.717 395.427C434.419 392.1 443.932 351.963 456.981 352.729L387.423 335.614Z",
    fill: "#90B1FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.188 280.971V294.477C103.191 296.99 104.192 299.399 105.968 301.176C107.745 302.953 110.154 303.953 112.667 303.957H126.279C126.312 300.92 125.736 297.908 124.586 295.097C123.436 292.287 121.735 289.735 119.583 287.592C117.43 285.45 114.871 283.76 112.055 282.623C109.239 281.486 106.224 280.924 103.188 280.971Z",
    fill: "#B1C9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M298.23 194.188C298.058 195.854 298.058 198.096 298.001 200.279C294.552 200.624 289.437 200.797 288.345 199.532L287.828 198.843C289.38 201.314 293.863 198.21 298.23 194.188Z",
    fill: "#316CF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M248.976 245.562C247.424 247.746 245.815 250.099 244.094 252.631V238.32C245.501 240.875 247.135 243.299 248.976 245.562Z",
    fill: "#316CF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M328.508 335.555L335.979 341.876L336.784 315.213C336.324 321.187 328.508 335.612 328.508 335.555Z",
    fill: "#316CF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M478.382 360.952C467.024 360.347 455.972 425.553 470.106 429.797C483.609 430.544 493.092 361.757 478.382 360.952Z",
    fill: "#316CF0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M451.947 391.182C448.457 389.467 444.739 388.265 440.906 387.612C442.171 395.946 447.349 398.136 452.981 392.101C452.636 391.814 452.349 391.526 451.947 391.182Z",
    fill: "#316CF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M457.637 352.789C456.462 352.626 455.264 352.756 454.151 353.168C453.038 353.579 452.044 354.26 451.258 355.148C454.419 356.056 458.097 356.984 461.718 357.789C461.495 356.686 461.007 355.655 460.296 354.783C459.585 353.912 458.673 353.227 457.637 352.789Z",
    fill: "#316CF0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M314.145 164.014C315.237 161.485 310.7 159.819 307.883 163.727C309.033 161.428 304.205 159.589 301.677 164.072C302.424 161.888 298.047 160.049 295.297 165.049C295.6 162.462 291.217 162.52 290.125 167.118C289.435 169.991 288.915 173.095 288.516 175.393C289.952 176.156 291.45 176.791 292.998 177.29C292.424 183.152 294.493 183.497 295.642 181.428C297.826 177.577 302.194 180.681 297.941 186.6C298.222 186.903 310.291 199.686 310.582 199.988C303.343 191.482 315.007 173.439 318.8 167.233C321.949 162.06 317.018 160.221 314.145 164.014Z",
    fill: "#316CF0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.617 331.034L50.2607 353.388C47.8711 355.777 51.5463 359.483 53.8905 357.017L76.2468 334.661C76.4849 334.423 76.6738 334.14 76.8026 333.829C76.9314 333.517 76.9976 333.184 76.9975 332.847C76.9973 332.51 76.9308 332.176 76.8018 331.865C76.6727 331.554 76.4836 331.271 76.2453 331.033C76.0069 330.795 75.724 330.606 75.4127 330.477C75.1014 330.348 74.7677 330.282 74.4308 330.282C74.0939 330.282 73.7603 330.349 73.4491 330.478C73.1379 330.607 72.8551 330.796 72.617 331.034Z",
    fill: "#90B1FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.617 331.023L50.2607 353.376C47.8711 355.766 51.5463 359.471 53.8905 357.006L76.2468 334.649C76.4849 334.411 76.6738 334.128 76.8026 333.817C76.9314 333.506 76.9976 333.172 76.9975 332.835C76.9973 332.498 76.9308 332.164 76.8018 331.853C76.6727 331.542 76.4836 331.259 76.2453 331.021C76.0069 330.783 75.724 330.594 75.4127 330.465C75.1014 330.337 74.7677 330.27 74.4308 330.271C74.0939 330.271 73.7603 330.337 73.4491 330.466C73.1379 330.595 72.8552 330.784 72.617 331.023Z",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M372.749 303.999L362.852 303.999",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M427.242 303.962H507.977C510.49 303.958 512.898 302.957 514.675 301.181C516.452 299.404 517.452 296.995 517.457 294.483V207.42",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M517.457 233.414V182.973C517.455 180.458 516.454 178.047 514.676 176.269C512.897 174.491 510.486 173.492 507.971 173.49H456.797",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M382.746 173.49H331.022C328.508 173.493 326.098 174.494 324.32 176.271C322.542 178.049 321.542 180.459 321.539 182.973V207.28",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M456.257 167.312V160.328H382.758V180.386H446.908",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M388.908 212.343H340.695V193.205H388.908V212.343Z",
    fill: "#1B44A4",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M352.711 231.7H388.915V247.792H365.067",
    fill: "#1B44A4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M352.711 231.7H388.915V247.792H365.067",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M340.695 276.065V267.271H344.029",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M356.382 283.314H349.141",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M380.742 267.271H388.903V276.352",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M288.889 173.49H237.891",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M103.188 263.092V182.973C103.19 180.459 104.189 178.049 105.967 176.271C107.744 174.494 110.154 173.493 112.667 173.49H152.18H174.453",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M207.89 180.386H199.442H174.453V160.328H185.83H237.89V180.386H210.878",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M212.481 240.786V282.622H122.375V260.323",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M279.947 210.843H231.734V192.51H279.947V210.843Z",
    fill: "#1B44A4",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M212.264 282.665H122.664V193.065H212.264L211.731 223.465L206.931 226.665L212.264 239.999V282.665Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M498.131 283.732H408.531V194.132H498.131V283.732Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M270.395 266.666H279.947V282.626H231.734V275.212",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M319.137 206.713C313.563 212.001 305.223 211.311 295.405 207.288C298.681 206.426 297.825 197.863 298.221 194.184C293.853 198.15 289.37 201.253 287.819 198.782C286.382 196.196 286.267 190.564 288.566 175.337C290.003 176.099 291.5 176.734 293.049 177.233C292.474 183.096 294.5 183.446 295.692 181.371C297.9 177.533 302.244 180.682 297.991 186.544C300.175 188.782 309.183 198.341 310.635 199.932C312.909 202.816 315.819 205.137 319.137 206.713Z",
    fill: "#FECFC4",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M319.148 206.706C327.814 208.823 335.7 213.358 341.889 219.782C358.873 235.85 371.68 262.559 408.223 295.203C406.445 299.921 403.655 304.193 400.049 307.718C396.443 311.242 392.109 313.935 387.352 315.605C366.09 295.375 351.378 279.459 335.93 255.206",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M298.23 194.177C298.058 195.843 298.058 198.085 298.001 200.269C294.552 200.614 289.437 200.786 288.345 199.522L287.828 198.832C289.38 201.303 293.863 198.2 298.23 194.177Z",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M244.094 238.355V252.608C245.809 250.092 247.421 247.747 248.955 245.573",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M283.164 249.295C276.819 259.582 269.196 269.024 260.478 277.395C251.797 285.607 236.676 282.803 229.907 272.97C220.4 258.575 212.718 243.055 207.039 226.766C214.598 220.438 224.024 216.764 233.872 216.309C237.41 226.77 242.498 236.641 248.966 245.592C254.894 237.011 259.323 230.68 262.949 225.961C271.056 215.275 275.009 212.598 282.659 210.447C286.392 209.397 291.34 208.33 295.363 207.286",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M328.516 335.6C328.516 335.6 336.274 321.233 336.791 315.201L335.987 341.865",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M281.507 241.304C281.507 241.304 288.464 274.462 291.736 279.519C281.966 342.789 269.9 470.822 267.602 493.291C280.635 498.863 295.153 499.935 308.863 496.337C308.863 496.337 325.802 365.487 328.524 335.605L371.05 371.579C374.667 374.675 378.925 376.933 383.518 378.188L445.696 395.369",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M478.378 360.945C467.489 360.34 458.414 415.969 466.693 427.636C467.197 428.476 467.969 429.123 468.885 429.471C469.8 429.82 470.807 429.85 471.742 429.557C472.362 429.363 472.93 429.031 473.405 428.589C485.027 419.463 491.854 361.683 478.378 360.945Z",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M274.038 495.821L273.131 503.522C272.707 507.271 271.313 510.844 269.084 513.887C266.856 516.931 263.872 519.34 260.426 520.876C251.409 524.913 242.902 530.006 235.085 536.048C234.849 536.236 234.679 536.492 234.595 536.782C234.512 537.071 234.521 537.379 234.621 537.663C234.721 537.947 234.906 538.193 235.152 538.367C235.397 538.541 235.691 538.635 235.992 538.634C261.679 538.634 283.227 538.404 303.748 538.347C303.972 531.551 302.939 524.771 300.702 518.35C300.419 517.479 300.341 516.555 300.472 515.649C300.971 511.795 302.081 501.224 302.426 497.545",
    fill: "#316CF0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M274.038 495.821L273.131 503.522C272.707 507.271 271.313 510.843 269.084 513.887C266.856 516.931 263.872 519.34 260.426 520.876C251.409 524.913 242.902 530.006 235.085 536.048C234.849 536.236 234.679 536.492 234.595 536.782C234.512 537.071 234.521 537.379 234.621 537.663C234.721 537.947 234.906 538.193 235.152 538.367C235.397 538.541 235.691 538.635 235.992 538.634C261.679 538.634 283.227 538.404 303.748 538.347C303.972 531.551 302.939 524.771 300.702 518.35C300.419 517.479 300.341 516.555 300.472 515.649C300.971 511.795 302.081 501.224 302.426 497.545L274.038 495.821Z",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M461.716 357.781C460.458 353.649 457.563 351.356 453.697 353.362C445.567 357.575 437.521 379.266 441.722 390.833C443.652 396.141 447.872 397.563 452.981 392.088",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M451.312 355.141C460.193 357.606 469.212 359.545 478.321 360.945",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M440.906 387.601C444.769 388.209 448.514 389.412 452.004 391.17C455.667 394.222 456.759 398.732 458.154 403.572C461.03 413.584 461.635 426.409 468.296 429.149",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M202.602 194.349C204.506 194.441 206.37 194.933 208.073 195.793C209.775 196.652 211.278 197.859 212.484 199.337",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M215.481 196.19C214.525 195.127 213.445 194.182 212.266 193.374",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M201.914 205.04C203.433 207.103 204.706 209.335 205.707 211.695",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M200.07 199.295C202.312 198.606 206.162 199.813 209.783 203.606",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M209.162 225.099C208.807 220.468 207.64 215.937 205.714 211.711C199.622 210.964 196.869 203.293 198.473 200.519C198.828 199.919 199.407 199.484 200.082 199.309C199.638 198.146 199.597 196.868 199.967 195.679C200.254 195.244 200.647 194.888 201.11 194.647C201.572 194.406 202.089 194.286 202.61 194.3C202.606 193.689 202.723 193.084 202.955 192.519C203.896 190.577 208.128 190.622 212.266 193.381C206.289 182.119 207.598 174.252 208.702 176.602C212.448 183.583 216.572 190.355 221.056 196.886C221.228 195.162 221.691 192.186 222.952 191.944C224.392 191.672 228.642 208.955 230.423 216.484",
    fill: "#FECFC4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M209.162 225.099C208.807 220.468 207.64 215.937 205.714 211.711C199.622 210.964 196.869 203.293 198.473 200.519C198.828 199.919 199.407 199.484 200.082 199.309C199.638 198.146 199.597 196.868 199.967 195.679C200.254 195.244 200.647 194.888 201.11 194.647C201.572 194.406 202.089 194.286 202.61 194.3C202.606 193.689 202.723 193.084 202.955 192.519C203.896 190.577 208.128 190.622 212.266 193.381C206.289 182.119 207.598 174.252 208.702 176.602C212.448 183.583 216.572 190.355 221.056 196.886C221.228 195.162 221.691 192.186 222.952 191.944C224.392 191.672 228.642 208.955 230.423 216.484C224.999 218.455 218.636 220.576 209.162 225.099Z",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M427.24 323.192C424.835 322.276 422.492 321.202 420.228 319.977C422.79 322.613 425.496 325.106 428.332 327.445C432.086 329.943 430.234 332.318 425.573 330.204C422.672 328.778 419.869 327.161 417.182 325.364C419.366 327.95 421.326 330.415 422.24 331.226C425.591 334.193 423.465 336.311 419.194 333.646C416.69 331.995 414.291 330.191 412.01 328.243C412.682 329.611 413.471 330.917 414.366 332.152C417.328 335.4 415.455 336.689 411.435 333.818C403.696 327.942 396.362 321.549 389.484 314.683C397.422 311.294 403.828 305.093 407.473 297.27C410.688 299.789 414.383 301.627 418.332 302.672C430.343 305.715 429.022 309.166 414.596 308.361C419.079 312.881 424.097 316.837 429.539 320.14C433.283 322.602 432.077 324.949 427.24 323.192Z",
    fill: "#FECFC4",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M414.773 316.699C416.095 317.561 417.992 318.768 420.233 319.975",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M414.534 308.365C413.672 307.457 412.753 306.526 411.891 305.491",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M410.289 320.659C411.55 321.567 414.194 323.418 417.183 325.314",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M406.945 323.708C407.98 324.742 409.876 326.409 411.942 328.191",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M288.578 175.335C288.98 173.036 289.443 169.99 290.13 167.117C291.228 162.522 295.59 162.461 295.302 165.048C298.061 160.048 302.429 161.887 301.685 164.071C304.21 159.588 309.038 161.427 307.888 163.726C310.705 159.818 315.242 161.484 314.15 164.013C317.023 160.22 321.966 162.059 318.808 167.232C315.106 173.281 303.911 190.61 310.097 199.349",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M536.773 220.576L557.983 238.267L536.773 255.925",
    stroke: "#0F172A",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8906 219.161L61.6813 236.852L82.8906 254.51",
    stroke: "#0F172A",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M282.711 210.441C282.711 210.441 295.01 255.78 283.231 249.247",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M330.422 211.137C335.171 215.804 337.031 231.536 336.471 241.536C335.685 252.349 335.8 263.21 336.816 274.004C349.554 279.736 356.632 292.891 362.043 304.001C369.284 319.001 387.451 335.616 387.451 335.616L457.436 352.791",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M290.062 208.604C292.129 214.506 293.667 220.579 294.66 226.753L327.026 225.891C325.897 219.694 324.322 213.588 322.313 207.618",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3865 319.876L76.2656 331.199",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M103.188 239.708V294.475C103.191 296.988 104.192 299.397 105.968 301.174C107.745 302.951 110.154 303.951 112.667 303.955H285.347",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M119.628 287.639C122.817 290.828 124.988 294.89 125.868 299.312C126.748 303.735 126.297 308.319 124.572 312.485C122.846 316.651 119.924 320.212 116.175 322.717C112.426 325.222 108.018 326.559 103.509 326.559C98.9997 326.559 94.5918 325.222 90.8426 322.717C87.0934 320.212 84.1714 316.651 82.446 312.485C80.7206 308.319 80.2693 303.735 81.1493 299.312C82.0293 294.89 84.201 290.828 87.3897 287.639C91.667 283.369 97.4644 280.97 103.509 280.97C109.553 280.97 115.351 283.369 119.628 287.639Z",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M221.055 196.88C222.208 199.025 223.151 201.277 223.871 203.604",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M287.312 248.545L296.68 279.519L274.039 495.647",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.41 5.66"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M333.625 325.083L380.286 365.482L440.627 382.781",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.41 5.66"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M237.656 225.957H262.998H237.656Z",
    fill: "#D9D9D9",
    stroke: "#0F172A",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M200.542 243.487H134.398V247.531H200.542V243.487Z",
    fill: "#96BFE6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M187.906 263.056H134.398V267.099H187.906V263.056Z",
    fill: "#96BFE6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M165.737 253.307H134.398V257.35H165.737V253.307Z",
    fill: "#96BFE6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M486.409 244.554H420.266V248.597H486.409V244.554Z",
    fill: "#96BFE6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M473.773 264.122H420.266V268.166H473.773V264.122Z",
    fill: "#96BFE6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M451.604 254.373H420.266V258.417H451.604V254.373Z",
    fill: "#96BFE6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M146.53 234.394C139.814 234.394 134.398 228.979 134.398 222.263C134.398 215.548 139.814 210.132 146.53 210.132C153.245 210.132 158.661 215.548 158.661 222.263C158.661 228.979 153.245 234.394 146.53 234.394ZM146.53 212.515C141.114 212.515 136.781 216.92 136.781 222.263C136.781 227.607 141.186 232.011 146.53 232.011C151.873 232.011 156.278 227.607 156.278 222.263C156.278 216.92 151.873 212.515 146.53 212.515Z",
    fill: "#4598E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M145.738 227.029L140.25 221.541L141.911 219.881L145.738 223.708L151.154 218.364L152.814 220.025L145.738 227.029Z",
    fill: "#4598E6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M432.397 235.461C425.681 235.461 420.266 230.045 420.266 223.329C420.266 216.614 425.681 211.198 432.397 211.198C439.112 211.198 444.528 216.614 444.528 223.329C444.528 230.045 439.112 235.461 432.397 235.461ZM432.397 213.581C426.981 213.581 422.648 217.986 422.648 223.329C422.648 228.673 427.053 233.078 432.397 233.078C437.74 233.078 442.145 228.673 442.145 223.329C442.145 217.986 437.74 213.581 432.397 213.581Z",
    fill: "#4598E6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M431.605 228.096L426.117 222.608L427.778 220.947L431.605 224.774L437.021 219.431L438.682 221.092L431.605 228.096Z",
    fill: "#4598E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance);
export default __webpack_public_path__ + "static/media/entrance.8d3daf00b85db51a504cf5e98fdcf793.svg";
export { ForwardRef as ReactComponent };